import React from 'react';
import { SEARCH } from './constants/search';
import './search-section.scss';

export const SearchSection = (props: { children?: React.ReactNode }) => {
  return (
    <div className="search-section">
      <h1 className="search-section-heading">{SEARCH.HEADING}</h1>
      {props.children}
    </div>
  );
};
